import React, { useState, useEffect } from "react";

export default function Profile(props) {
  const [state, setState] = useState(null);

  return <div>Profile</div>;
}
